import React from "react";
import { observer } from "mobx-react";
import LivePlayerStatisticsStore from "@state/stores/offer/statistics/LivePlayerStatisticsStore";

import { PlayerStatisticsTable } from "./PlayerStatisticsTable";

export default observer(function GroupedPlayerStatsTable(props: {
	store: LivePlayerStatisticsStore;
}) {
	return (
		<div className="event__content">
			{props.store.playerStatsGroups.map(
				(group, index) =>
					group.key === props.store.playerFilter && (
						<PlayerStatisticsTable
							key={group.key}
							index={index}
							statsGroup={group}
							store={props.store}
							playerFilter={props.store.activeTab}
							setPlayerFilter={props.store.setPlayerFilter}
						/>
					)
			)}
		</div>
	);
});
